module.exports = __webpack_public_path__ + "img/individual.9a95b40e.svg";